import useAsclepius from "@common/composables/api/asclepius"
import { Ref, ref, watch } from "vue"
import { Entitlement, MedicalService } from "@vitable/asclepius-api-client-ts"

export const useGetCompanyEntitlements = () => {
  const { getEntitlementsApi, callWithResponse, callResult } = useAsclepius()
  const entitlements: Ref<Array<Entitlement>> = ref([])

  async function getCompanyEntitlements(companyId: string) {
    await callWithResponse(() =>
      getEntitlementsApi().listAllEntitlementsForCompany({
        companyId: companyId
      })
    )
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      entitlements.value = newValue.data.entitlements
    }
  })

  return {
    entitlements,
    getCompanyEntitlements,
    getCompanyEntitlementsResult: callResult
  }
}

export const useGetCompanyEntitledMedicalServices = () => {
  const { getEntitlementsApi, callWithResponse, callResult } = useAsclepius()
  const medicalServices: Ref<Array<MedicalService>> = ref([])

  async function getCompanyEntitledMedicalServices(companyId: string) {
    await callWithResponse(() =>
      getEntitlementsApi().listAllEntitledMedicalServicesForCompany({
        companyId: companyId
      })
    )
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      medicalServices.value = newValue.data.medical_services
    }
  })

  return {
    medicalServices,
    getCompanyEntitledMedicalServices,
    getCompanyEntitledMedicalServicesResult: callResult
  }
}
